import ReportsCatalogService from './reports-catalog.ts';

/**
 * Dashboards are the same `report` resource, addressed by
 * report_type='dashboard'. That value is intentionally NOT part of the
 * builder-product set (VALID_REPORT_TYPES), so the dashboards home needs its
 * own `filter[report_type]` value and its own client-side type gate rather
 * than the reports defaults. Kept alongside VALID_REPORT_TYPES /
 * REPORT_TYPE_FILTER_VALUE (which stay report-only) instead of folding into
 * them.
 */
export const DASHBOARD_REPORT_TYPE = 'dashboard';

/** report_type values the dashboards catalog surfaces. */
const DASHBOARD_ALLOWED_TYPES = new Set<string>([DASHBOARD_REPORT_TYPE]);

/**
 * The dashboards catalog is the reports catalog retargeted to
 * report_type='dashboard': identical load / cache / archive / owner-scoping
 * machinery, only the server filter and the client-side visibility gate
 * differ. Resolved as `service:dashboards-catalog` (tio-reporting's
 * compat-modules glob over `src/services/**` registers it by filename — no app
 * re-export needed), a singleton distinct from `reports-catalog` so the two
 * homes keep independent caches.
 */
export default class DashboardsCatalogService extends ReportsCatalogService {
  protected get reportTypeFilter() {
    return DASHBOARD_REPORT_TYPE;
  }

  protected get allowedReportTypes() {
    return DASHBOARD_ALLOWED_TYPES;
  }
}
